var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.imgList),function(img){return _c('section',[_c('img',{attrs:{"src":img,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }